module.exports = __webpack_public_path__ + "img/hsk_2.e39a3164.png";